module.exports = Em.Handlebars.compile("<inbox-module {{bind-attr organizationId=activeOrganization.id}} customerView=true />\n");